import { Box, MenuItem, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ColorScheme } from "../../Themes/ColorScheme";
import TooltipWrapper from "./TooltipWrapper";

let style = {
	// saved from local component level styling to here⁄
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	borderRadius: "4px",
	width: "100%",
	height: "100%",
	minHeight: "75px",
	maxHeight: "75px",
	backgroundColor: ColorScheme.lightGrey,
	marginBottom: "10px", // todo fix this, remove (10px) and use gap property in parent
	alignSelf: "center",
	boxSizing: "border-box",
	border: "1px solid " + ColorScheme.darkGrey + ColorScheme.opacity25,
	overflow: "hidden",
	icon: {
		height: "40px",
		minHeight: "40px",
		maxHeight: "40px",
		width: "40px",
		minWidth: "40px",
		maxWidth: "40px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		boxSizing: "border-box",
		marginLeft: "20px",
		cursor: "pointer"
	},

	select: {
		// not in use
		minHeight: "50px",
		backgroundColor: ColorScheme.textFieldBackground,
		height: undefined,
		"& .MuiOutlinedInput-root": {
			position: "relative",
			// top: "7px",
			backgroundColor: "inherit"
		},

		"fieldset.MuiOutlinedInput-notchedOutline": {
			border: "none"
		},
		"& .MuiFormLabel-root": {
			top: "0px",
			transition: "all 0.2s ease-in-out" // slower animation transition
		},
		"&.Mui-focused": {
			color: ColorScheme.black,
			top: "2px"
		},
		"& .MuiInputLabel-root.Mui-focused": {
			/* color: ColorScheme.black, */
			top: "10px"
		},
		"& .Mui-active": {
			color: ColorScheme.black
		},
		"& .MuiSelect-icon": {
			/* top: "5px", */
			transition: "all 0.2s ease-in-out" // slower animation transition
		}
	},

	pickers: {
		width: "100%",
		height: "100%",
		backgroundColor: ColorScheme.textFieldBackground,
		minHeight: "75px",
		"& .MuiInputBase-root": {
			// should cover TextField with select property
			minHeight: "55px",
			backgroundColor: ColorScheme.textFieldBackground,
			"fieldset.MuiOutlinedInput-notchedOutline": {
				border: "none"
			}
		},
		"& .MuiOutlinedInput-root": {
			minHeight: "75px",
			backgroundColor: "inherit",
			position: "relative",
			top: "7px"
		},
		"& .MuiOutlinedInput-notchedOutline": {
			border: "none"
		},
		fieldset: {
			border: "none"
		},
		label: {
			fontSize: "14px",
			top: "28px"
		}
	},

	"& .MuiInputBaseRoot": {
		// should cover TextField with select property
		minHeight: "55px",
		backgroundColor: ColorScheme.textFieldBackground,
		"fieldset.MuiOutlinedInput-notchedOutline": {
			border: "none"
		}
	},
	"& .MuiOutlinedInput-notchedOutline": {
		border: 0
	}
};

export const TextFieldSelect = ({
	valueChange,
	selected,
	label,
	options,
	removeIcon,
	helpText,
	hasProps
}) => {
	const { t } = useTranslation();
	const [isOpen, setIsOpen] = useState(false);

	const handleChange = (event) => {
		const value = event.target.value;
		valueChange(value);
	};

	return (
		<Box
			style={{  ...style, pointerEvents: "auto" }}
			onClick={() => setIsOpen(!isOpen)}
		>
			{!removeIcon && hasProps && (
				<Box style={style.icon}>
					<TooltipWrapper title={helpText}>{hasProps}</TooltipWrapper>
				</Box>
			)}

			<TextField
				select
				fullWidth
				notched={false}
				label={label}
				displayEmpty
				labelId="custom-select"
				value={selected}
				onChange={handleChange}
				open={isOpen}
				onClose={() => setIsOpen(false)}
				onOpen={() => setIsOpen(true)}
				sx={{
					...style.select,
					"& .MuiSelect-icon": {
						top:
							selected === undefined
								? "15px"
								: label === undefined ||
									  label === null ||
									  label === ""
									? "15px"
									: "8px"
					}
				}}
				SelectProps={{
					style: {
						top:
							selected === "" ||
							selected === undefined ||
							selected === null
								? "5px"
								: label === undefined ||
									  label === null ||
									  label === ""
									? "0px"
									: "10px"
					}
				}}
				InputLabelProps={{
					style: {
						fontSize: "14px",
						top:
							selected === "" ||
							selected === undefined ||
							selected === null
								? "5px"
								: "20px",
						"& .Mui-active": {
							top: "20px"
						}
					}
				}}
			>

				{options &&
					options.map((type) => (
						<MenuItem
							value={
								isNaN(selected) &&
								Number(selected) === Number(0) // fixes the issue with 0 being falsy and not being selected
									? 0
									: type?.value !== undefined &&
										  type?.value !== null
										? type?.value
										: type?.id !== undefined &&
											  type?.id !== null
											? type?.id
											: type?.type_id !== undefined &&
												  type?.type_id !== null
												? type?.type_id
												: type
							}
							key={type?.value || type?.id || type?.label || type}
						>
							<Typography fontSize="15px">
								{/* {type?.image && <img src={type?.image} alt={type?.label} />} */}
								{type?.label ||
									(type?.name_en !== undefined &&
										t(`reservables.${type?.name_en}`)) ||
									type?.title ||
									type?.value ||
									type?.name ||
									type}
							</Typography>
						</MenuItem>
					))}
			</TextField>
		</Box>
	);
};
